export default {
  title: 'نيبولا بودز الذكاء الاصطناعي للمكالمات', // "Nebula buds AI通话" 翻译为阿拉伯语
  userID: 'معرف المستخدم : ', // "用户ID : "
  hurryUp: 'انتظر مكالمة من الطرف الآخر', // "等待对方呼叫"
  waitingCall: 'انتظر مكالمة من الطرف الآخر على هذه الصفحة، لا تغلق الصفحة مسبقاً.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'مفتاح الترجمة', // "字幕开关"
  initWait: 'انتظر التهيئة', // "等待初始化"
  initSuccess: 'تم التهيئة بنجاح، انتظر مكالمة من الطرف الآخر. لا تغلق الصفحة!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'تم الاتصال', // "电话接通"
  callEnd: 'انتهت المكالمة', // "通话结束"
  careful: 'تحذير : ', // "注意 : "
  wait: 'تم تجهيز مكون المكالمات، انتظر مكالمة من الطرف الآخر', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'العربية', // "阿拉伯语"
    da: 'الدنماركية', // "丹麦语"
    de: 'الألمانية', // "德语"
    en: 'الإنجليزية', // "英语"
    es: 'الإسبانية', // "西班牙语"
    fil: 'الفلبينية', // "菲律宾语"
    fr: 'الفرنسية', // "法语"
    hi: 'الهندية', // "印地语"
    id: 'الإندونيسية', // "印度尼西亚语"
    it: 'الإيطالية', // "意大利语"
    ja: 'اليابانية', // "日文"
    ko: 'الكورية', // "韩语"
    ms: 'الماليزية', // "马来语"
    no: 'النرويجية', // "挪威语"
    pt: 'البرتغالية', // "葡萄牙语"
    ru: 'الروسية', // "俄语"
    sv: 'السويدية', // "瑞典语"
    th: 'التايلندية', // "泰语"
    tr: 'التركية', // "土耳其语"
    vi: 'الفيتنامية', // "越南语"
    zh: 'الصينية' // "中文"
  }
}
